import React, { Component }from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import axios from '../../../axios/axios';
import FaqItem from './FaqItem';
import Loader from '../../components/loader/loader';
import { translateStaticContent } from '../../../helpers/translateStaticContent';

class Faqs extends Component {
    constructor(props) {
        super(props)
        this.state = {
            faqs: [],
            loading: false
        }
    }

    componentDidMount() {
      this.getFaqs();
    }

    componentDidUpdate(prevProps) {
      if (this.props.activeLang !== prevProps.activeLang) {
        this.getFaqs();
      }
    }

    getFaqs = () => {
      axios.defaults.headers.isocode = this.props.activeLang ? this.props.activeLang : 'uk';
      this.setState({...this.state, loading: true }, () => {
        axios.get(`/api/welsend/public/faqs`)
          .then(res => {
            const faqs = res.data;
            this.setState({faqs, loading: false})
          })
      })
    }

  render() {   
      let faqItem =  this.state.faqs.map(faq =>  <FaqItem id={faq.id} name={faq.name} text={faq.text} key={faq.id}/>)
      return (
        <div className="container faqs">
            <h1>
              {translateStaticContent('faqs', 
                this.props.defaultStaticContentFaqs, this.props.activeLangStaticContentFaqs)}
            </h1>
            {this.state.loading ? <Loader /> : 
              <div>{faqItem}</div>
            }
        </div>
      )
    }
}

const mapStateToProps = state => ({
  activeLang: state.lang.activeLang
})
export default connect(mapStateToProps)(Faqs);

Faqs.propTypes = {
  activeLang: PropTypes.string.isRequired,
  defaultStaticContentFaqs: PropTypes.object,
  activeLangStaticContentFaqs: PropTypes.object,
}